/* eslint-disable react-hooks/exhaustive-deps */
import { Row, Switch } from 'antd'
import { useTranslation } from 'next-i18next'
import { ConsentPayload } from 'src/core/models'
import React, { useEffect, useState } from 'react'
import { FormLabels, CustomCol } from 'src/components'
import { CheckOutlined, CloseOutlined } from '@ant-design/icons'
import { changeUserConsent, userAuthenticatedState } from 'src/features'
import { useAppDispatch, useAppSelector, useWindowSize } from 'src/app/hooks'

interface Props { consentType: 'COMMERCIAL' | 'SUSCRIBE_SALES' }

const UserPreferenceChangeConsent: React.FC<Props> = ({ consentType }) => {
  const { t } = useTranslation()
  const dispatch = useAppDispatch()
  const user = useAppSelector(userAuthenticatedState)
  const [consent, setConsent] = useState<boolean>(false)
  const { isMobile } = useWindowSize()

  const handleConsentChange = (value: boolean) => {
    setConsent(value)
    const payload: ConsentPayload = {
      COMMERCIAL: { commercial_communications: value },
      SUSCRIBE_SALES: { allow_sales_and_offers: value }
    }[consentType]
    dispatch(changeUserConsent(payload))
  }

  useEffect(() => {
    const consent = user?.consent
    if (consent) {
      const value = {
        COMMERCIAL: consent.commercial_communications,
        SUSCRIBE_SALES: consent.allow_sales_and_offers
      }[consentType]
      setConsent(value)
    }
  }, [])

  const labels = {
    COMMERCIAL: { title: t('settings.CommercialCommunicationsConsent'), subtitle: t('settings.CommercialCommunicationsConsentLabel') },
    SUSCRIBE_SALES: { title: t('settings.Suscribe.Title'), subtitle: t('settings.Suscribe.Subtitle') },
  }[consentType]

  return (
    <Row className={isMobile && 'mt-5'}>
      <CustomCol xs={19}>
        <FormLabels
          title={labels.title}
          subtitle={labels.subtitle}
        />
      </CustomCol>
      <CustomCol xs={5}>
        <Switch
          checked={consent}
          className={isMobile && 'mt-2 ml-3'}
          onChange={handleConsentChange}
          checkedChildren={<CheckOutlined />}
          unCheckedChildren={<CloseOutlined />}
        />
      </CustomCol>
    </Row>
  )
}

export default UserPreferenceChangeConsent
